// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_MEf","clinicsSelect":"styles_clinicsSelect__16PA9"};